import { ThreeView } from "../View3dWebCad";
import * as THREE from 'three';
import * as marietta from '../../../';
import { MasterItemCollection } from '../../../webcad/collection';
import { ChangeWallMaterial } from "./changeWallMaterial";
import { MonicaObject } from '../../../webcad/item';

export class ChangePointWall extends ChangeWallMaterial {

    constructor(wall: THREE.Object3D) {
        super(wall);
    }

    protected getTexture(index: number): THREE.Texture {
        return ThreeView.get().matmgr.me.materials().clothTexes[index];
    }

    protected getTextureByName(name: string): THREE.Texture {
        return ThreeView.get().matmgr.me.materials().clothTexes.find((texture) => {
            return name == texture.name;
        })
    }

    protected isWallType = (name: string): boolean => {
        return name.match(/^rom.*-wall-node/) != null;
    }

    protected side(): number {
        return 0;           //内壁
    }

    public setToEndItem( info:MasterItemCollection ) {
        marietta.webcad.WebCADGlobal.itemManager.updateWallEndItem(this.wall.userData.guid, 0, info );
    }
    public getEndItem():MasterItemCollection {
        return marietta.webcad.WebCADGlobal.itemManager.getWallEndItem(this.wall.userData.guid, 0 );
    }
    public get2D():MonicaObject{
        return marietta.webcad.WebCADGlobal.itemManager.getWallParentItem( this.wall.userData.guid );
    }
    public getTargetGuid():string{
        return this.wall.userData.guid;
    }
}
